import {type DeltaQueryTypeOverride} from '../types';

/**
 * Resolves the admin-only delta query override against the viewer's privileges.
 * A saved value only takes effect for W&B admins on non-server deployments;
 * every other viewer (and every server deployment) resolves to undefined, so a
 * persisted value can never affect query selection for non-admins.
 */
export function resolveDeltaQueryTypeOverride(
  savedValue: DeltaQueryTypeOverride | undefined,
  viewerIsAdmin: boolean | null | undefined,
  isServerDeployment: boolean
): DeltaQueryTypeOverride | undefined {
  return !isServerDeployment && viewerIsAdmin ? savedValue : undefined;
}
